import React from "react";
import "../../Components/Boot/Boot.css";
import "./RefundPolicy.css";
import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";
import MobileFooter from "../../Components/Mobile/MobileFooter";

function RefundPolicy() {
  return (
    <div>
      <Navbar />
      <div className="refund-wrapper d-flex align-items-center justify-content-center mb-3">
        <div className="refund-container">
          <h1>TB Mart - Refund Policy</h1>
          <p className="last-updated">Last Updated: August 11, 2025</p>

          <section>
            <h2>1. Our Commitment to Quality</h2>
            <p>
              At TB Mart, we are committed to delivering fresh, high-quality
              groceries and essential items to your doorstep. We understand that
              issues can sometimes arise, and this policy outlines our
              procedures for refunds, returns, and replacements to ensure a fair
              and transparent process for our valued customers. This policy
              should be read in conjunction with our Terms and Conditions.
            </p>
          </section>

          <section>
            <h2>2. Eligibility for a Refund, Return, or Replacement</h2>
            <p>
              You are eligible to request a refund, return, or replacement under
              the following circumstances. All issues must be reported within 4
              hours of delivery.
            </p>
            <ul>
              <li>
                Damaged or Defective Items: You received a product that is
                crushed, broken, leaking, or otherwise physically damaged.
              </li>
              <li>
                Wrong Item Delivered: You received an item that you did not
                order.
              </li>
              <li>
                Missing Item: An item that was part of your confirmed order and
                was paid for is missing from your delivery.
              </li>
              <li>
                Expired Product: You received a product that was past its "Best
                Before" or "Expiry" date at the time of delivery.
              </li>
              <li>
                Spoiled Perishable Goods: You received a fresh produce item
                (e.g., fruits, vegetables, dairy, meat) that is clearly spoiled,
                wilted, or not fit for consumption upon arrival.
              </li>
            </ul>
          </section>

          <section>
            <h2>3. Non-Refundable and Non-Returnable Items</h2>
            <p>
              Due to health and safety regulations, we cannot accept returns or
              issue refunds for:
            </p>
            <ul>
              <li>Items that have been opened, used, or partially consumed.</li>
              <li>
                Products where the original packaging or seal has been tampered
                with by the customer.
              </li>
              <li>
                Items for which a refund request was not submitted within the
                4-hour window after delivery.
              </li>
              <li>
                Change-of-mind purchases. Please review your cart carefully
                before confirming your order.
              </li>
            </ul>
          </section>

          <section>
            <h2>4. How to Request a Refund or Replacement</h2>
            <p>To ensure a swift resolution, please follow these steps:</p>
            <ol>
              <li>
                Inspect Your Order: Upon delivery, please inspect all items
                immediately.
              </li>
              <li>
                Contact Us Promptly: You must contact our Customer Support team
                within 4 hours of receiving your order. You can reach us via:
                <ul>
                  <li>Email: support@trendbayds.com</li>
                  <li>Phone/WhatsApp: +234 704-127-5289</li>
                  <li>Live Chat</li>
                </ul>
              </li>
              <li>
                Provide Necessary Details: In your communication, please
                include:
                <ul>
                  <li>Your Order Number.</li>
                  <li>
                    A clear description of the issue (e.g., "missing item,"
                    "damaged milk carton").
                  </li>
                  <li>
                    Clear photographic evidence of the damaged, wrong, or
                    expired item. This is mandatory for processing your claim.
                  </li>
                </ul>
              </li>
            </ol>
            <p>
              Our team will review your claim within 24 hours and inform you of
              the resolution.
            </p>
          </section>

          <section>
            <h2>5. Refund Methods and Timelines</h2>
            <ul>
              <li>
                <strong>TB Mart Store Credit:</strong> The refund amount is
                credited to your TB Mart account wallet instantly. This is the
                fastest option and can be used for future purchases.
              </li>
              <li>
                <strong>Refund to Original Payment Method:</strong> The amount
                will be refunded to the debit/credit card or bank account used
                for the purchase. Please allow 5-10 business days for the amount
                to reflect in your account, depending on your bank's processing
                times.
              </li>
            </ul>
            <p>
              Delivery fees are non-refundable once a delivery has been
              successfully completed.
            </p>
          </section>

          <section>
            <h2>6. Replacement and Exchange Policy</h2>
            <ul>
              <li>
                <strong>Process:</strong> If a replacement is approved, we will
                arrange for the new item to be delivered to you at no extra
                charge during our next available delivery slot to your area.
              </li>
              <li>
                <strong>Availability:</strong> Replacements are subject to stock
                availability. If the item is unavailable, we will issue a refund
                as per Section 5.
              </li>
            </ul>
          </section>

          <section>
            <h2>7. Impact of Promotional Items and Discounts</h2>
            <ul>
              <li>
                The refund amount will be adjusted to reflect the discounted
                price you paid for the item.
              </li>
              <li>
                If the promotion involved a "buy one, get one free" offer, both
                items may need to be returned to qualify for a full refund.
              </li>
            </ul>
          </section>

          <section>
            <h2>8. Conditions Under Which a Refund May Be Denied</h2>
            <ul>
              <li>
                The request is made after the 4-hour reporting window has
                passed.
              </li>
              <li>
                No clear photographic evidence is provided to support the claim.
              </li>
              <li>
                Our investigation determines the product was damaged or spoiled
                after delivery due to customer mishandling.
              </li>
              <li>
                The item is non-refundable as per Section 3 of this policy.
              </li>
            </ul>
          </section>

          <section>
            <h2>9. Customer Responsibilities</h2>
            <ul>
              <li>
                Keep the problematic item in its original packaging until the
                claim is resolved, as we may need to arrange for its collection
                for quality inspection.
              </li>
              <li>
                Provide accurate and complete information when submitting your
                claim.
              </li>
            </ul>
          </section>

          <section>
            <h2>10. Disclaimer of Liability</h2>
            <p>
              TB Mart is not liable for issues arising from factors outside of
              our direct control, such as incorrect delivery information
              provided by the customer or inability to receive the order at the
              scheduled time.
            </p>
          </section>

          <section>
            <h2>11. Contact Us</h2>
            <p>
              For all refund-related inquiries, please contact our dedicated
              Customer Support team:
              <br />
              TB Mart Customer Support <br />
              Email:{" "}
              <a href="mailto:support@trendbayds.com">support@trendbayds.com</a>
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default RefundPolicy;
